module.exports = __webpack_public_path__ + "img/Kinto_Blue_height_30.0831d9bd.png";